'use strict';

var accordion = require('../../../../../../../../../../_virtual/accordion.cjs');

var hasRequiredAccordion;

function requireAccordion () {
	if (hasRequiredAccordion) return accordion.__exports;
	hasRequiredAccordion = 1;

	var ACCORDION_SIZES = /*#__PURE__*/ function(ACCORDION_SIZES) {
	    ACCORDION_SIZES["small"] = "small";
	    ACCORDION_SIZES["medium"] = "medium";
	    ACCORDION_SIZES["large"] = "large";
	    return ACCORDION_SIZES;
	}({});

	accordion.__exports.ACCORDION_SIZES = ACCORDION_SIZES;
	
	return accordion.__exports;
}

exports.__require = requireAccordion;
//# sourceMappingURL=accordion.cjs.map
